import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column mb-3",
  style: {"max-height":"600px","overflow-y":"auto"}
}
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "d-flex d-flex justify-content-around align-items-center mb-6 bg-light-primary rounded p-5" }
const _hoisted_4 = { class: "symbol symbol-100px symbol-lg-120px symbol-fixed position-relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bold me-1"
}
const _hoisted_9 = { href: "#" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-sm btn-light-success fw-bold ms-2 fs-8 py-1 px-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_upgrade_plan"
}, "My Bacera", -1)
const _hoisted_12 = { class: "d-flex fw-semobold fs-6 mb-4 pe-2" }
const _hoisted_13 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_14 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_15 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_18 = { class: "mt-6" }
const _hoisted_19 = { class: "bg-light-warning rounded p-4 mb-7" }
const _hoisted_20 = { class: "row mb-7 fs-4" }
const _hoisted_21 = { class: "col-lg-6 fw-semobold text-muted" }
const _hoisted_22 = { class: "col-lg-6" }
const _hoisted_23 = { class: "fw-bold text-dark" }
const _hoisted_24 = {
  key: 0,
  class: "row mb-7 fs-4"
}
const _hoisted_25 = { class: "col-lg-6 fw-semobold text-muted" }
const _hoisted_26 = { class: "col-lg-6" }
const _hoisted_27 = { class: "fw-bold text-dark" }
const _hoisted_28 = { class: "row mb-7 fs-4" }
const _hoisted_29 = { class: "col-lg-6 fw-semobold text-muted" }
const _hoisted_30 = { class: "col-lg-6" }
const _hoisted_31 = { class: "fw-bold text-dark" }
const _hoisted_32 = { class: "row fs-4" }
const _hoisted_33 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_34 = { class: "col-lg-6" }
const _hoisted_35 = { class: "fw-bold text-success" }
const _hoisted_36 = {
  key: 0,
  class: "bg-light-danger p-4 rounded mb-7"
}
const _hoisted_37 = { class: "row fs-4" }
const _hoisted_38 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "fw-bold text-danger" }
const _hoisted_41 = {
  key: 1,
  class: "bg-light-danger p-4 rounded mb-7"
}
const _hoisted_42 = { class: "row fs-4" }
const _hoisted_43 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_44 = { class: "col-lg-8" }
const _hoisted_45 = { class: "fw-bold text-danger" }
const _hoisted_46 = { class: "row fs-4 mt-4" }
const _hoisted_47 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_48 = { class: "col-lg-8" }
const _hoisted_49 = { class: "fw-bold text-danger" }
const _hoisted_50 = {
  key: 2,
  class: "bg-light-danger p-4 rounded mb-7"
}
const _hoisted_51 = {
  key: 0,
  class: "row fs-4"
}
const _hoisted_52 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_53 = { class: "col-lg-6" }
const _hoisted_54 = { class: "fw-bold text-danger" }
const _hoisted_55 = {
  key: 1,
  class: "row fs-4"
}
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_58 = { class: "col-lg-6" }
const _hoisted_59 = { class: "fw-bold text-danger" }
const _hoisted_60 = { class: "row mt-7" }
const _hoisted_61 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_62 = { class: "col-lg-6" }
const _hoisted_63 = { class: "fw-bold text-danger" }
const _hoisted_64 = {
  key: 0,
  class: "row mt-7"
}
const _hoisted_65 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_66 = { class: "col-lg-6 d-flex justify-content-between align-items-center" }
const _hoisted_67 = { class: "fw-bold text-danger" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = {
  key: 1,
  class: "row mt-7"
}
const _hoisted_71 = { class: "col-lg-6 fw-bold text-muted mb-3" }
const _hoisted_72 = { class: "col-lg-12 fw-bold" }
const _hoisted_73 = { class: "mb-3" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = { class: "text-danger" }
const _hoisted_76 = { class: "ms-2" }
const _hoisted_77 = { class: "mb-3" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = { class: "text-danger" }
const _hoisted_80 = { class: "ms-2 text-danger" }
const _hoisted_81 = { class: "mb-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_83 = { class: "text-danger" }
const _hoisted_84 = { class: "ms-2 text-danger" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_86 = { class: "text-danger" }
const _hoisted_87 = { class: "ms-2 text-danger" }
const _hoisted_88 = {
  key: 2,
  class: "row mt-7"
}
const _hoisted_89 = { class: "col-lg-6 fw-bold text-muted mb-3" }
const _hoisted_90 = { class: "col-lg-12 fw-bold" }
const _hoisted_91 = { class: "mb-3" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_93 = { class: "text-danger" }
const _hoisted_94 = { class: "ms-2 text-danger" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_96 = { class: "text-danger" }
const _hoisted_97 = { class: "ms-2 text-danger" }
const _hoisted_98 = {
  key: 3,
  class: "bg-light-danger p-4 rounded mb-7"
}
const _hoisted_99 = { class: "row fs-4 mb-5" }
const _hoisted_100 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_101 = { class: "col-lg-6" }
const _hoisted_102 = { class: "fw-bold text-danger" }
const _hoisted_103 = { class: "row fs-4 mb-5" }
const _hoisted_104 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_105 = { class: "col-lg-6" }
const _hoisted_106 = { class: "fw-bold text-danger" }
const _hoisted_107 = { class: "row fs-4 mb-5" }
const _hoisted_108 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_109 = { class: "col-lg-6" }
const _hoisted_110 = { class: "fw-bold text-danger" }
const _hoisted_111 = { class: "row fs-4 mb-5" }
const _hoisted_112 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_113 = { class: "col-lg-6" }
const _hoisted_114 = { class: "fw-bold text-danger" }
const _hoisted_115 = { class: "row fs-4 mb-5" }
const _hoisted_116 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_117 = { class: "col-lg-6" }
const _hoisted_118 = { class: "fw-bold text-danger" }
const _hoisted_119 = { class: "row fs-4 mb-5" }
const _hoisted_120 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_121 = { class: "col-lg-6" }
const _hoisted_122 = { class: "fw-bold text-danger" }
const _hoisted_123 = { class: "row fs-4" }
const _hoisted_124 = { class: "col-lg-6 fw-bold text-muted" }
const _hoisted_125 = { class: "col-lg-6" }
const _hoisted_126 = { class: "fw-bold text-danger" }

import { ref, onMounted, nextTick } from "vue";
import AuthImage from "@/components/AuthImage.vue";
import TimeShow from "@/components/TimeShow.vue";
import GlobalService from "@/projects/client/services/ClientGlobalService";
import { ApplicationType } from "@/core/types/ApplicationInfos";
// import { FormRules } from "element-plus";
import SimpleForm from "@/components/SimpleForm.vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import QuizRecordModal from "./modal/ViewQuizRecordModal.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationDetailsPanel',
  props: {
    beforeClose: { type: Function }
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;



const modalRef = ref<InstanceType<typeof SimpleForm>>();
const isLoading = ref(true);
const isSubmitting = ref(true);
const applicationDetails = ref<any>({});
const { t } = useI18n();

const serviceMap = ref({} as any);
const formData = ref({} as any);

const quizRecordModalRef = ref<InstanceType<typeof QuizRecordModal>>();

const channel2q4Options = ref({
  1: t("wholesale.q4Option1"),
  2: t("wholesale.q4Option2"),
  3: t("wholesale.q4Option3"),
  4: t("wholesale.q4Option4"),
  5: t("wholesale.q4Option5"),
  6: t("wholesale.q4Option6"),
});

const approve = async () => {
  try {
    isSubmitting.value = true;
    await AccountService.approveApplicationsById(
      applicationDetails.value.id,
      formData.value
    );
    MsgPrompt.success().then(() => {
      emits("submit");
      modalRef.value?.hide();
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const reject = async () => {
  try {
    isSubmitting.value = true;
    await AccountService.rejectApplicationsById(
      applicationDetails.value.id,
      formData.value
    );
    MsgPrompt.success().then(() => {
      emits("submit");
      modalRef.value?.hide();
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const showquizRecord = (_QnA: any) => {
  quizRecordModalRef.value?.show(_QnA);
};

__expose({
  show: async (_applicationDetails: any) => {
    modalRef.value?.show();
    applicationDetails.value = _applicationDetails;
    await nextTick();
    isLoading.value = false;
  },
  hide: () => modalRef.value?.hide(),
});

onMounted(async () => {
  serviceMap.value = await GlobalService.getServiceMap();
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('title.applicationDetails'),
    "is-loading": isLoading.value,
    "save-title": _ctx.$t('action.approve'),
    "discard-title": _ctx.$t('action.reject'),
    submit: approve,
    discard: reject,
    "discard-color": `danger`,
    width: 500,
    "before-close": props.beforeClose
  }, {
    default: _withCtx(() => [
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(AuthImage, {
                    imageGuid: applicationDetails.value.user.avatar
                  }, null, 8, ["imageGuid"]),
                  _hoisted_5
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("a", _hoisted_8, _toDisplayString(applicationDetails.value.user.name), 1),
                    _createElementVNode("a", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(_component_inline_svg, { src: "/images/icons/general/gen026.svg" })
                      ])
                    ]),
                    _hoisted_11
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, { src: "/images/icons/communication/com006.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(applicationDetails.value.user.uid), 1)
                    ]),
                    _createElementVNode("a", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_inline_svg, { src: "/images/icons/communication/com011.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(applicationDetails.value.user.email), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("fields.partyId")), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(applicationDetails.value.partyId), 1)
                  ])
                ]),
                (
              applicationDetails.value.supplement.accountUid ||
              applicationDetails.value.supplement.AccountUid
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("fields.uid")), 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(applicationDetails.value.supplement.accountUid ??
                  applicationDetails.value.supplement.AccountUid), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(TimeShow, {
                        "date-iso-string": applicationDetails.value.createdOn
                      }, null, 8, ["date-iso-string"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("fields.type")), 1),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t(`type.application.${applicationDetails.value.type}`)), 1)
                  ])
                ])
              ]),
              (
            _unref(ApplicationType).TradeAccountChangeLeverage ==
            applicationDetails.value.type
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("fields.newLeverage")), 1),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, _toDisplayString((applicationDetails.value.supplement.leverage ??
                    applicationDetails.value.supplement.Leverage) + ":1"), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(ApplicationType).WholesaleReferral == applicationDetails.value.type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("fields.referral") + " " + _ctx.$t("fields.email")), 1),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("span", _hoisted_45, _toDisplayString(applicationDetails.value.supplement.email), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("fields.referral") + " " + _ctx.$t("fields.account")), 1),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(applicationDetails.value.supplement.accountNumber), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(ApplicationType).WholeSaleAccount == applicationDetails.value.type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (applicationDetails.value.supplement.request.started.method == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("fields.method")), 1),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("tip.wealthThresholdApplication")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (applicationDetails.value.supplement.request.started.method == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("fields.method")), 1),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("tip.sophisticatedInvestorTest")), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t("fields.channel")), 1),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("span", _hoisted_63, _toDisplayString([
                      _ctx.$t("tip.knowledgeTestTradeHistory"),
                      _ctx.$t("tip.relevantWorkExperience"),
                      _ctx.$t("tip.relevantFormalQualifications"),
                    ][applicationDetails.value.supplement.request.channel.channel - 1]), 1)
                            ])
                          ]),
                          (applicationDetails.value.supplement.request.channel.channel == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t("fields.supplement")), 1),
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("span", _hoisted_67, [
                                    (
                      applicationDetails.value.supplement.request.supplement
                        .wrongAns > 1
                    )
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.$t("tip.testFailType")), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.$t("tip.testPassType")), 1)),
                                    _createTextVNode(" (" + _toDisplayString(10 -
                    applicationDetails.value.supplement.request.supplement.wrongAns) + "/10) ", 1)
                                  ]),
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (
                    showquizRecord(
                      applicationDetails.value.supplement.request.supplement.questions
                    )
                  ))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("View Record")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (applicationDetails.value.supplement.request.channel.channel == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("fields.supplement")), 1),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("wholesale.channelTwoQ1")) + " ", 1),
                                    _hoisted_74,
                                    _createElementVNode("span", _hoisted_75, [
                                      _createTextVNode(" Ans:"),
                                      _createElementVNode("span", _hoisted_76, _toDisplayString(applicationDetails.value.supplement.request.supplement.q1), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_77, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("wholesale.channelTwoQ2")) + " ", 1),
                                    _hoisted_78,
                                    _createElementVNode("span", _hoisted_79, [
                                      _createTextVNode(" Ans:"),
                                      _createElementVNode("span", _hoisted_80, _toDisplayString(applicationDetails.value.supplement.request.supplement.q2), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_81, [
                                    _createTextVNode(" 3." + _toDisplayString(_ctx.$t("wholesale.channelTwoQ3")) + " ", 1),
                                    _hoisted_82,
                                    _createElementVNode("span", _hoisted_83, [
                                      _createTextVNode("Ans:"),
                                      _createElementVNode("span", _hoisted_84, _toDisplayString(applicationDetails.value.supplement.request.supplement.q3), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createTextVNode(" 4." + _toDisplayString(_ctx.$t("wholesale.channelTwoQ4")) + " ", 1),
                                    _hoisted_85,
                                    _createElementVNode("span", _hoisted_86, [
                                      _createTextVNode(" Ans:"),
                                      _createElementVNode("span", _hoisted_87, _toDisplayString(channel2q4Options.value[
                        applicationDetails.value.supplement.request.supplement.q4
                      ]), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (applicationDetails.value.supplement.request.channel.channel == 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("fields.supplement")), 1),
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("wholesale.channelThreeQ1")) + " ", 1),
                                    _hoisted_92,
                                    _createElementVNode("span", _hoisted_93, [
                                      _createTextVNode("Ans:"),
                                      _createElementVNode("span", _hoisted_94, _toDisplayString(applicationDetails.value.supplement.request.supplement.q1), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("wholesale.channelThreeQ2")) + " ", 1),
                                    _hoisted_95,
                                    _createElementVNode("span", _hoisted_96, [
                                      _createTextVNode(" Ans:"),
                                      _createElementVNode("span", _hoisted_97, _toDisplayString(applicationDetails.value.supplement.request.supplement.q2), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_unref(ApplicationType).Account == applicationDetails.value.type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t("fields.type")), 1),
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.$t(
                    `type.account.${applicationDetails.value.supplement.accountType}`
                  )), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t("fields.accountRole")), 1),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$t(`type.account.${applicationDetails.value.supplement.role}`)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.$t("fields.leverage")), 1),
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("span", _hoisted_110, _toDisplayString(applicationDetails.value.supplement.leverage + ":1"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.$t("fields.currency")), 1),
                      _createElementVNode("div", _hoisted_113, [
                        _createElementVNode("span", _hoisted_114, _toDisplayString(applicationDetails.value.supplement.currencyId
                    ? _ctx.$t(
                        `type.currency.${applicationDetails.value.supplement.currencyId}`
                      )
                    : "***"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.$t("fields.platform")), 1),
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("span", _hoisted_118, _toDisplayString(serviceMap.value[applicationDetails.value.supplement.platform]
                    .platformName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_119, [
                      _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.$t("fields.server")), 1),
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("span", _hoisted_122, _toDisplayString(serviceMap.value[applicationDetails.value.supplement.platform].serverName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t("fields.referralCode")), 1),
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("span", _hoisted_126, _toDisplayString(applicationDetails.value.supplement.referCode
                    ? applicationDetails.value.supplement.referCode
                    : "***"), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(QuizRecordModal, {
        ref_key: "quizRecordModalRef",
        ref: quizRecordModalRef
      }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "is-loading", "save-title", "discard-title", "before-close"]))
}
}

})